
const digest = '185b1732258f74bc56772bbb023adf45c9a85d44286ad158cbd2ef3a25fd8ee5';
const classes = {"wrapper":"_wrapper_13hzj_1"};
const css = `._wrapper_13hzj_1 {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  gap: 3px;
  font-weight: 500;
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  